module.exports = __webpack_public_path__ + "static/media/hello-beautiful-50-background.35dc379a.jpg";